import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { ITargetRange } from "../ITargetRange";
import { BaseCareElementConfig } from "./BaseCareElementConfig";
import { CareElementType } from "./CareElementType";

class VitalSignsCareElementConfig extends BaseCareElementConfig {
    public readonly CareElementType: CareElementType.VitalSigns;
    public Frequency?: CareElementFrequencyType;
    public TargetRange?: ITargetRange;
    public Operator?: CareElementOperatorType;
    public Unit?: string;

    public constructor(init: Omit<NonFunctionProperties<VitalSignsCareElementConfig>, "CareElementType">) {
        super({ ...init, CareElementType: CareElementType.VitalSigns });
        Object.assign(this, init);
    }
}

export { VitalSignsCareElementConfig };
